module.exports = __webpack_public_path__ + "img/Group 339.129034b0.png";